module.exports = __webpack_public_path__ + "static/media/users-solid.22e09537.svg";